import { Currency } from '../shared';

export type CurrencyRangeValue = Record<Currency, number>;

export const fractionDigitsCurrency: Record<Currency, number> = {
  CZK: 1,
  EUR: 3,
};

export const sliderStepCurrency: Record<Currency, number> = {
  CZK: 0.1,
  EUR: 0.005,
};
